import React, {useState, useEffect} from 'react';
import Loader from "react-loader-spinner";
import ReactPaginate from 'react-paginate';
import * as typingCenterUserActions from '../../Redux/Actions/typingCenterUser';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import {toastMessage} from '../../utils/toast';
import { clearSession } from '../../utils/initiate';
import Warning from '../Ui/400';
import { search } from '../../utils';
import { setUserIdFilter, setUserNameFilter, resetUserFilter } from '../../Redux/Reducers/commonFilters';

const UserManagement = ({ history }) => {

    let itemsPerPage = 10;
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [parmenentData, setParmenentData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);

    const dispatch = useDispatch();
    const { userIdFilter, userNameFilter } = useSelector(state => state.commonFilters);

    useEffect(() => {
        setLoading(true);
        typingCenterUserActions.getAll().then(res => {
            if(res && res.data){
                setData(res.data);
                setParmenentData(res.data);
                if(userIdFilter || userNameFilter) {
                    handleFilter(res.data);
                }
            }else{
                toastMessage('error', (res && res.message) || `Unable to load the users`);
            }
            setLoading(false);
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, data]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    if(errStatus === 400){
        return <Warning history={history} />
    }

    const handleFilter = (arr) => {
        let temp = null;

        if(userIdFilter && userNameFilter) {
            const filtered = search({ items: arr, searchParams: ["id"], filterSearch: userIdFilter });
            temp = search({ items: filtered, searchParams: ["name"], filterSearch: userNameFilter });
        } else if(userIdFilter) {
            temp = search({ items: arr, searchParams: ["id"], filterSearch: userIdFilter });
        } else if(userNameFilter) {
            temp = search({ items: arr, searchParams: ["name"], filterSearch: userNameFilter });
        }

        temp && setData(temp);
    };
   
    const clearFilter = () => {
        setData(parmenentData);
        dispatch(resetUserFilter());
    }

    return(
        <>
            <div className="container-fluid">
                <div className="page-title-box">
                    <h4 className="page-title my-2">{t("userManagement.manageUser.title")}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-custom card-stretch gutter-b">
                            {loading ? <Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                            : <div className="card-body p-3">
                                <div className="tab-content">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="me-3" style={{ width: '20%' }}>
                                            <label className="mb-1 ms-1 me-3">{t("filter.id")}</label>
                                            <input placeholder={t("filter.idPlaceholder")} type="number" className="form-control me-3" name="Filter ID" value={userIdFilter} onChange={(e) => dispatch(setUserIdFilter(e.target.value))}/>
                                        </div>
                                        <div className="me-3" style={{ width: '20%' }}>
                                            <label className="mb-1 ms-1 me-3">{t("filter.name")}</label>
                                            <input placeholder={t("filter.namePlaceholder")} type="text" className="form-control me-3" name="Filter ID" value={userNameFilter} onChange={(e) => dispatch(setUserNameFilter(e.target.value))} />
                                        </div>
                                    </div>
                                    <div className="d-flex mb-3">
                                        <button onClick={() => handleFilter(data)} type="button" className="d-flex px-5 align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.filter")}</button>
                                        <button onClick={clearFilter} type="button" className="px-5 d-flex align-items-center btn btn-primary font-weight-bold mx-2" >{t("jobsManagement.filters.clearFilters")}</button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-head-custom table-vertical-center table-head-bg">
                                            <thead>
                                                <tr className="text-left">
                                                    <th style={{minWidth: '100px'}} className="pl-7">
                                                        <span className="text-dark-75">{t("userManagement.manageUser.sNo")}</span>
                                                    </th>
                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("userManagement.manageUser.typingCenterID")}</span></th>
                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("userManagement.manageUser.name")}</span></th>
                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("userManagement.manageUser.email")}</span></th>
                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("userManagement.manageUser.mobileNumber")}</span></th>
                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("userManagement.manageUser.extensionNumber")}</span></th>
                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("userManagement.addUser.emiratesId")}</span></th>
                                                    <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("userManagement.manageUser.action")}</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems && currentItems.map(({id, name, email, mobileNumber, extensionNumber, emiratesId, typingCenterId}, index) => <tr key={index}>
                                                    <td className="pl-7">
                                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{index + 1}</span>
                                                    </td>
                                                    <td>
                                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{id}</span>
                                                    </td>
                                                    <td className="pl-0 py-8">
                                                        <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{name}</span>
                                                    </td>
                                                    <td>
                                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{email}</span>
                                                    </td>
                                                    <td>
                                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{mobileNumber}</span>
                                                    </td>
                                                    <td>
                                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{extensionNumber}</span>
                                                    </td>
                                                    <td>
                                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{emiratesId}</span>
                                                    </td>
                                                    <td className="pr-0">
                                                        <p onClick={() => history.push(`/user/info?userID=${id}`)} className="btn btn-warning font-weight-bolder font-size-sm me-2">{t("userManagement.manageUser.more")}</p>
                                                        <p onClick={() => history.push(`/user/update?userID=${id}`)} className="btn btn-info font-weight-bolder font-size-sm">{t("userManagement.manageUser.update")}</p>
                                                    </td>
                                                </tr>)}
                                            </tbody>
                                        </table>
                                        {(pageCount > 1) && <ReactPaginate
                                            breakLabel="..."
                                            nextLabel=">"
                                            previousLabel="<"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={5}
                                            pageCount={pageCount}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            containerClassName="pagination"
                                            activeClassName="active"
                                            renderOnZeroPageCount={null}
                                        />}
                                        {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("userManagement.noDataAvailable")}</p>}
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserManagement;